import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseurladdress } from "../baseurl";
import Sidennav from "../dashboard/sidenavbar";
import Topnavbar from "../dashboard/topnavbar";
import Group from "./group";
import RoleList from "./role";
import { Modal, Button, ModalHeader, ModalFooter } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import { Form } from "react-bootstrap";
import Select from "react-select";

import $ from 'jquery';

import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
function Userlist() {
  const Swal = require('sweetalert2')

  const accessuserid = localStorage.getItem("id");
  const accesstoken = localStorage.getItem("token");
  const [data, setData] = useState([]);
  const [button, setbutton] = useState("Users");
  const [User, setUser] = useState(false);
  const [role, setrole] = useState(false);
  const [group, setgroup] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [rolename, setRolename] = useState("");
  const [roledescr, setRoledescr] = useState("");

  const [ERoles, setERoles] = useState(false);


  const [username, setusername] = useState("");
  const [disname, setdisname] = useState("");
  const [userpassword, setuserpassword] = useState("");
  const [eduser, seteduser] = useState(false);
  const [usernameedit, setusernameedit] = useState("");
  const [disnameedit, setdisnameedit] = useState("");
  const [passeedit, setpasseedit] = useState("");
  const [status, setstatus] = useState("");
  const [statval, setstatval] = useState("");
  const [userid, setuserid] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [groupname, setgroupname] = useState("");
  const [groupdescr, setgroupdescr] = useState("");

  const [staffname, setstaffname] = useState([]);
  const [sname, setsname] = useState("");

  const [edstaffname, setedstaffname] = useState([]);
  const [edsname, setedsname] = useState("");

  // const [roleedit, setroleedit] = useState("");

  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState("");
  const [rolelist, setRolelist] = useState([]);
  const [userroleAdd, setUserroleAdd] = useState("");

    

   // const [selectedBranches, setSelectedBranches] = useState([]);
    const [branchName, setBranchName] = useState("");
    const [branches, setBranches] = useState([]);
    const [selectedBranches, setSelectedBranches] = useState([]);


    const [branchRegions, setBranchRegions] = useState([]);
    const [showBranchDropdown, setShowBranchDropdown] = useState(false);
    const [branchSearch, setBranchSearch] = useState("");
  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };


  const navigate = useNavigate();

  // Handle button click to toggle modal
  const handleClick = () => {
    setShowModal(!showModal);
  };

  // Add role
  const handleSubmit = (event) => {
    event.preventDefault();
    // Validate the rolename field
    if (!rolename.trim()) {
      document.getElementById('rolename').focus();
      return;
    }
    // Validate the roledescr field
    if (!roledescr.trim()) {
      document.getElementById('descrption').focus();
      return;
    }
    const data = {
      role_name: rolename,
      role_description: roledescr,
      role_crtby: accessuserid
    };

    axios.post(baseurladdress + `addroles`, data, {
      headers: {
        Authorization: `Bearer ${accesstoken}`,
      },
    })
      .then((response) => {
        console.log(response)
        if (response.data.status === "success") {
          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 1800,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer);
              toast.addEventListener('mouseleave', Swal.resumeTimer);
            }
          });
          Toast.fire({
            icon: 'success',
            title: 'Role added successfully'
          });
          setrole(false);
          setRolename('');
          setRoledescr('');
          
        } else {
          console.error('Failed to add role:', response.data.status);
        }
      })
      .catch((error) => {
        console.error('Error during axios request:', error);
      });
  };
  // List all users
  const GetAllUsers = () => {
    axios
      .get(baseurladdress + `findallusers`, {
        headers: { Authorization: `Bearer ${accesstoken}` },
      })
      .then((res) => {
        const datas = res.data.response;
        console.log("itemss" + datas);
        const user = datas.map((item, index) => (
          <tr id={"chk" + item.user_id}>
            <td>{index + 1}</td>
            <td>{item.user_name}</td>
            <td>{item.user_display}</td>
            <td>
              {" "}
              <div>
                {(() => {
                  if (item.user_status == 1) {
                    return (
                      <div>
                        <span class="badge bg-success">Active</span>
                      </div>
                    );
                  } else {
                    return (
                      <div>
                        <span class="badge bg-danger">Inactive</span>
                      </div>
                    );
                  }
                })()}
              </div>
            </td>
            <td style={{ textAlign: "center" }}>
              <i
                class="text-primary fa fa-edit"
                style={{ cursor: "pointer" }}
                onClick={() => handleEditClick(item.user_id)}
              ></i>
            </td>
            <td style={{ textAlign: "center" }}>
              <i
                class="text-danger fa fa-trash"
                style={{ cursor: "pointer" }}
                onClick={() => handleDeleteUser(item.user_id)}
              ></i>
            </td>
          </tr>
        ));
        setData(user);
      })
      .catch((error) => {
        alert(error);
      });
  };
  useEffect(() => {
    GetAllUsers();

  }, []);


  const changerole = (event) => {
    setbutton("Roles");
  };

  const changegroup = (event) => {
    setbutton("Groups");
  };

  const changeuser = (event) => {
    setbutton("Users");
  };

  const handleclick = (event) => {
    if (button == "Users") {
      setUser(true);
    } else if (button == "Roles") {
      setrole(true);
    } else {
      setgroup(true);
    }
    };

  
  const handleUserSubmit = (e) => {
    e.preventDefault();
    // Validate the rolename field
    if (!username.trim()) {
      document.getElementById('username').focus();
      return;
    }
    // Validate the roledescr field
    if (!disname.trim()) {
      document.getElementById('dname').focus();
      return;
    }
    if (!userpassword.trim()) {
      document.getElementById('password').focus();
      return;
    }
    const data = {
      user_name: username,
      user_display: disname,
      user_password: userpassword,
      user_staffid: sname,
      user_crtby: accessuserid,
      user_role: userroleAdd,
    };
    axios
      .post(baseurladdress + `adduser`, data, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then((res) => {
        if (res.data.status === "success") {
          const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 2500,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", Swal.stopTimer);
              toast.addEventListener("mouseleave", Swal.resumeTimer);
            },
          });
          Toast.fire({
            icon: "success",
            title: "User added successfully",
          });
          setUser(false);
          setusername("");
          setdisname("");
          setuserpassword("");
          setUserroleAdd("");
          GetAllUsers();
        } else {
          alert("Failed");
        }
      })
      .catch((error) => {
        alert(error);
      });
    };

    //fetch branch region
    const getBranchRegions = async () => {

        try {

            const response = await axios.get(
                `${baseurladdress}branchregion`,
                {
                    headers: {
                        Authorization: `Bearer ${accesstoken}`
                    }
                }
            );

            setBranchRegions(response.data.response || []);

        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getBranchRegions();
    }, []);


    const groupedBranches = branchRegions.reduce((acc, item) => {

        if (!acc[item.region_name]) {
            acc[item.region_name] = [];
        }

        acc[item.region_name].push(item);

        return acc;

    }, {});

    useEffect(() => {

        const handleClickOutside = (event) => {

            if (!event.target.closest(".position-relative")) {
                setShowBranchDropdown(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener(
                "mousedown",
                handleClickOutside
            );
        };

    }, []);


    const handleEditClicknow = (userId) => {
        seteduser(true);
        setuserid(userId);

        axios
            .get(`${baseurladdress}edituser/${userId}`, {
                headers: {
                    Authorization: `Bearer ${accesstoken}`,
                },
            })
            .then((res) => {

                const data = res.data.response;

                setusernameedit(data[0].user_name);
                setdisnameedit(data[0].user_display);
                setSelectedRole(data[0].user_role);
                setpasseedit(data[0].user_password);
                setstatus(data[0].user_status);
                setedsname(data[0].user_staffid);
                setBranchName(data[0].branch_name || "");

                getallstaff();

                // Load all branches first
                axios
                    .get(`${baseurladdress}getallbranchs`, {
                        headers: {
                            Authorization: `Bearer ${accesstoken}`,
                        },
                    })
                    .then((branchRes) => {

                        const allBranches = branchRes.data.response;

                        setBranches(allBranches);

                        const storedBranches =
                            data[0].user_branches
                                ? data[0].user_branches
                                    .split(",")
                                    .map(Number)
                                : [];

                        const selected = allBranches
                            .filter((branch) =>
                                storedBranches.includes(
                                    Number(branch.branch_id)
                                )
                            )
                            .map((branch) => ({
                                value: branch.branch_id,
                                label: branch.branch_name,
                            }));

                        setSelectedBranches(selected);
                    });
            })
            .catch((error) => {
                console.log(error);
            });
    };
    const handleEditClick = async (userId) => {

        try {

            seteduser(true);
            setuserid(userId);

            const userRes = await axios.get(
                `${baseurladdress}edituser/${userId}`,
                {
                    headers: {
                        Authorization: `Bearer ${accesstoken}`,
                    },
                }
            );

            const userData = userRes.data.response[0];

            setusernameedit(userData.user_name);
            setdisnameedit(userData.user_display);
            setSelectedRole(userData.user_role);
            setpasseedit(userData.user_password);
            setstatus(userData.user_status);
            setedsname(userData.user_staffid);
            setBranchName(userData.branch_name || "");

            getallstaff();

            // Load branches
            const branchRes = await axios.get(
                `${baseurladdress}getallbranchs`,
                {
                    headers: {
                        Authorization: `Bearer ${accesstoken}`,
                    },
                }
            );

            const allBranches = branchRes.data.response;

            setBranches(allBranches);

            // Convert saved branch IDs from DB
            const storedBranches =
                userData.user_branches
                    ? userData.user_branches
                        .split(",")
                        .map(id => Number(id))
                    : [];

            console.log("Stored Branches:", storedBranches);

            // IMPORTANT
            // selectedBranches should contain IDs only
            setSelectedBranches(storedBranches);

        } catch (error) {

            console.log(error);

            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Unable to fetch user details"
            });
        }
    };
  // const handleEditClick = (userId) => {
  //   seteduser(true);
  //   setuserid(userId);
  //   console.log(userId, "userIduserIduserId");
  //   axios
  //     .get(baseurladdress + `edituser/` + userId, {
  //       headers: { Authorization: `Bearer ${accesstoken}` },
  //     })
  //     .then((res) => {
  //       const data = res.data.response;
  //       setusernameedit(data[0].user_name);
  //       setdisnameedit(data[0].user_display);
  //       setSelectedRole(data[0].user_role);
  //       setpasseedit(data[0].user_password);
  //       setstatus(data[0].user_status);
  //         setedsname(data[0].user_staffid);
  //         setBranchName(data[0].branch_name || "");
  //         getallstaff();
  //         getAllBranches();
  //     })
  //     .catch((error) => {
  //       alert(error);
  //     });
  // };

    const handleUserUpdate = (e) => {
        e.preventDefault();

        // const branchIds = selectedBranches
        //     .map((item) => item.value)
        //     .join(",");
        const branchIds = selectedBranches.join(",");
        const data = {
            user_name: usernameedit,
            user_display: disnameedit,
            user_role: selectedRole,
            user_password: passeedit,
            user_status: status,
            user_updby: accessuserid,
            user_staffid: edsname,
            user_id: userid,
            user_branches: branchIds,
        };

        console.log("Sending Data:", data);

        axios
            .post(
                `${baseurladdress}updateuser`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                }
            )
            .then((result) => {
                console.log(result.data);

                if (result.data.status === "success") {

                    Swal.fire({
                        icon: "success",
                        title: "Success",
                        text: "User Updated Successfully",
                    });
                    // Clear form fields
                    setSelectedBranches([]);
                    setusernameedit("");
                    setdisnameedit("");
                    setSelectedRole("");
                    setpasseedit("");
                    setstatus("");
                    setedsname("");
                    setuserid("");

                    seteduser(false);
                    GetAllUsers();
                }
            })
            .catch((error) => {
                console.log(error);

                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "Failed to update user",
                });
            });
    };

  
  function handleDeleteUser(ids) {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085D6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        {
          axios
            .post(baseurladdress + `deleteuser/` + ids, data, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            })
            .then((result) => {
              console.log("reslt:", result);
              const Data = result.data.status;
              if (Data == "deleted") {
                const Toast = Swal.mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 2500,
                  timerProgressBar: true,
                  didOpen: (toast) => {
                    toast.addEventListener("mouseenter", Swal.stopTimer);
                    toast.addEventListener("mouseleave", Swal.resumeTimer);
                  },
                });
                Toast.fire({
                  icon: "success",
                  title: "User data Deleted Successfully",
                });
                GetAllUsers();
              }
            });
        }
      }
    });
  }
  // add groups
  const handlegroupSubmit = () => {
    if (!groupname.trim()) {
      document.getElementById("groupname").focus();
      return;
    }
    if (!groupdescr.trim()) {
      document.getElementById("grpdescrption").focus();
      return;
    }
    const data = {
      group_name: groupname,
      group_description: groupdescr,
      group_crtbby: accessuserid,
    };
    axios
      .post(baseurladdress + `addgroups`, data, {
        headers: {
          Authorization: `Bearer ${accesstoken}`,
        },
      })
      .then((response) => {
        console.log(response);
        if (response.data.status === "success") {
          const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 1800,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", Swal.stopTimer);
              toast.addEventListener("mouseleave", Swal.resumeTimer);
            },
          });
          Toast.fire({
            icon: "success",
            title: "Group Data added successfully",
          });

          setgroup(false);
          setgroupname("");
          setgroupdescr("");
        } else {
          console.error("Failed to add role:", response.data.status);
        }
      })
      .catch((error) => {
        console.error("Error during axios request:", error);
      });
  };

  $(function () {
    setTimeout(function () {
      $('#userlist').DataTable();
    }, 1000);
  });

  useEffect(() => {
    const getstaff = () => {
      axios.get(baseurladdress + `getallstaff`, {
        headers: { Authorization: `Bearer ${accesstoken}` },
      })
        .then(res => {
          const data = res.data.response;
          // console.log(data);
          const staff = data.map((item, index) => {
            return (
              <option value={item.staff_id}> {item.staff_name} </option>
            )
          }
          );
          setstaffname(staff);
        }).catch(error => {
          alert(error);
        })
    }
    getstaff()




  }, [])
  const getallstaff = () => {
    axios
      .get(baseurladdress + `getallstaff`, {
        headers: { Authorization: `Bearer ${accesstoken}` },
      })
      .then((res) => {
        const data = res.data.response;
        setedstaffname(data); // save raw data
      })
      .catch((error) => {
        alert(error);
      });
  };

  useEffect(() => {
    const getroless = () => {
      axios.get(baseurladdress + `findallactiveroles`, {
        headers: { Authorization: `Bearer ${accesstoken}` },
      })
        .then(res => {
          const data = res.data.response;
          setRoles(data);
        }).catch(error => {
          alert(error);
        });
    };
    getroless();
  }, []);
  

  useEffect(() => {
    const getroleess = () => {
      axios.get(baseurladdress + `findallactiveroles`, {
        headers: { Authorization: `Bearer ${accesstoken}` },
      })
        .then(res => {
          const data = res.data.response;
          setRolelist(data);
        })
        .catch(error => {
          alert(error);
        });
    };
    getroleess();
  }, []);

  // const getallstaff = () => {
  //   axios.get(baseurladdress + `getallstaff`, {
  //     headers: { Authorization: `Bearer ${accesstoken}` },
  //   })
  //     .then(res => {
  //       const data = res.data.response;
  //       console.log(data);
  //       const user = data.map((item, index) => {
  //         var selectedd = (item.staff_id == edsname
  //         ) ? ' selected' : '';
  //         return (
  //           <option value={item.staff_id} selected={selectedd}> {item.staff_name} </option>
  //         )
  //       }
  //       );
  //       setedstaffname(user);
  //     }).catch(error => {
  //       alert(error);
  //     })
  // }

  return (
    <div className="content-wrap">
      <div className="main">
        <div className="container-fluid">
          {/* /# row */}
          <section id="main-content">
            <div class="card">
              <div class="card-body">
                <div class="row mb-2">
                  <div class="col-sm-12 float-lg-right text-right">
                    {/* <button
                      type="button"
                      class="d-grid gap-2 d-md-flex justify-content-md-end"
                      className="btn btn-primary"
                      id="adduserButton"
                      onClick={handleclick}
                    >

                      Add {button}
                    </button> */}
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
                      <button
                        type="button"
                        className="btn plus-icon d-flex align-items-center"
                        onClick={handleclick}
                      >
                        <span style={{ fontSize: "1.2rem" }}>
                          <i className='fa fa-plus-circle text-success'></i>
                        </span>
                        <span style={{ fontSize: "0.7rem", color: "black", padding: "5px" }}>
                          Add
                        </span>
                      </button>
                    </div>

                  </div>
                </div>
                <div class="default-tab">
                  <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item">
                      <a
                        class="nav-link active"
                        data-toggle="tab"
                        href="#user"
                        onClick={changeuser}
                      >
                        Users
                      </a>
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        data-toggle="tab"
                        href="#role"
                        onClick={changerole}
                      >
                        Roles
                      </a>
                    </li>
                    {/* <li class="nav-item">
                      <a
                        class="nav-link"
                        data-toggle="tab"
                        href="#group"
                        onClick={changegroup}
                      >
                        Groups
                      </a>
                    </li> */}
                  </ul>
                  <div class="tab-content">
                    <div
                      class="tab-pane fade show active"
                      id="user"
                      role="tabpanel"
                    >
                      <div className="col-lg-12">
                        <div className="card">
                          <div className="card-body">
                            <div className="table-responsive">
                              <table className="table table-bordered table-responsive-sm" id="userlist">
                                <thead>
                                  <tr >
                                    <th>Sl.No</th>
                                    <th>Username</th>
                                    <th>Display Name</th>
                                    <th>Status</th>
                                    <th>Edit</th>
                                    <th>Delete</th>
                                  </tr>
                                </thead>
                                <tbody>{data}</tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <div class="tab-pane fade" id="group">
                      <Group groups={group} />
                    </div> */}

                    <div class="tab-pane fade" id="role">
                      <RoleList role={role} />
                    </div>
                  </div>
                </div>

                <Modal className="modal-size md modal-top-center" show={role} style={{ display: "flex" }}>
                  <Modal.Header>
                    <h6>ADD Role</h6>

                    <span
                      aria-hidden="true"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setrole(false);
                      }}
                    >
                      ×
                    </span>
                  </Modal.Header>
                  <Modal.Body className="css">
                    <form >
                      <div>
                        <h6>Roles</h6>
                        <input type="text" className="form-control" id="rolename" value={rolename} onChange={(e) => setRolename(e.target.value)} /></div>
                      <div>
                        <h6>Description</h6>
                        <textarea className="form-control" id="descrption" style={{ height: '200px' }} value={roledescr} onChange={(e) => setRoledescr(e.target.value)}></textarea>
                      </div>
                    </form>
                  </Modal.Body>
                  <ModalFooter>
                    <div className="row w-100">
                      <div className="col-auto ml-auto">

                        <button type="button" className="btn btn-primary ml-2" onClick={handleSubmit}>
                          Save changes
                        </button>
                      </div>
                    </div>
                  </ModalFooter>
                </Modal>

                {/* add user */}

                <Modal className="modal-size md modal-top-center" show={User} style={{ display: "flex" }}>
                  <Modal.Header>
                    <h6>ADD USER</h6>

                    <span
                      aria-hidden="true"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setUser(false);
                      }}
                    >
                      ×
                    </span>
                  </Modal.Header>
                  <Modal.Body className="css">
                    <form >
                      <div className="row">

                        <div className="col-md-12">
                          <h6>Staff Name</h6>
                          <select
                            className="form-control select"
                            name="staff"
                            onChange={e => { setsname(e.target.value) }}
                            required
                          >
                            <option value="" disabled selected>
                              Select
                            </option>
                            {staffname}
                          </select>
                        </div>
                        <div className="col-md-6">
                          <h6>User Name</h6>
                          <input
                            text="text"
                            required
                            className="form-control"
                            id="username"
                            value={username}
                            onChange={(e) => setusername(e.target.value)}
                          ></input>
                        </div>
                        <div className="col-md-6">
                          <h6>Display Name</h6>
                          <input
                            text="text"
                            className="form-control"
                            id="dname"
                            value={disname}
                            required
                            onChange={(e) => setdisname(e.target.value)}
                          ></input>
                        </div>
                        <div className="col-md-12">
                          <h6>Role</h6>
                          <select
                            className="form-control select"
                            id="userroleAdd"
                            value={userroleAdd}
                            onChange={(e) => setUserroleAdd(e.target.value)}
                            required
                          >
                            <option value="" disabled selected>
                              Select Role
                            </option>
                            {rolelist.map((role) => (
                              <option key={role.role_id} value={role.role_id}>
                                {role.role_name}
                              </option>
                            ))}
                          </select>
                        </div>


                        <div className="col-md-12">
                          <h6>Password</h6>
                          <div className="input-group">
                            <input
                              type={passwordVisible ? "text" : "password"}
                              required
                              className="form-control"
                              id="password"
                              value={userpassword}
                              onChange={(e) => setuserpassword(e.target.value)}
                            />
                            <div className="input-group-append">
                              <button
                                className="btn btn-outline-secondary"
                                type="button"
                                onClick={togglePasswordVisibility}
                              >
                                <i className={passwordVisible ? "fa fa-eye-slash" : "fa fa-eye"}></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </Modal.Body>
                  <ModalFooter>
                    <div className="row w-100">
                      <div className="col-auto ml-auto">

                        <button
                          type="button"
                          className="btn btn-primary"
                          id="saveuser"
                          onClick={handleUserSubmit}
                        >
                          SAVE
                        </button>
                      </div>
                    </div>
                  </ModalFooter>
                </Modal>
                {/* edit user */}

                <Modal className="modal-size md modal-top-center" show={eduser} style={{ display: "flex" }}>
                  <Modal.Header>
                    <h6>EDIT USER</h6>

                    <span
                      aria-hidden="true"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        seteduser(false);
                      }}
                    >
                      ×
                    </span>
                  </Modal.Header>
                  <Modal.Body className="css">
                    <form >
                      <div className="row">

                        <div className="col-md-12">
                          <h6>Staff Name</h6>
                          {/* <select
                            className="form-control select"
                            name="staff"
                            value={edstaffname}
                          onChange={e => { getallstaff(e.target.value); setedsname(e.target.value) }}
                            required
                          >
                            <option value="" disabled selected>
                              Select
                            </option>
                            {edstaffname}
                          </select> */}
                          <select
                            className="form-control select"
                            name="staff"
                            value={edsname}
                            onChange={(e) => setedsname(e.target.value)}
                            required
                          >
                            <option value="" disabled>
                              Select
                            </option>
                            {edstaffname.map((item) => (
                              <option key={item.staff_id} value={item.staff_id}>
                                {item.staff_name}
                              </option>
                            ))}
                          </select>

                        </div>
                        <div className="col-md-6">
                          <h6>User Name</h6>
                          <input
                            text="text"
                            required
                            className="form-control"
                            value={usernameedit}
                            onChange={(e) => setusernameedit(e.target.value)}
                          ></input>
                        </div>
                        <div className="col-md-6 mt-2">
                          <h6>Display Name</h6>
                          <input
                            text="text"
                            className="form-control"
                            value={disnameedit}
                            onChange={(e) => setdisnameedit(e.target.value)}
                          ></input>
                        </div>


                        <div className="col-md-12 mt-2">
                          <h6>Role</h6>
                          <select
                            className="form-control"
                            value={selectedRole}
                            onChange={(e) => setSelectedRole(e.target.value)}
                          >
                            <option value="" disabled>Select role</option>
                            {roles.map((r) => (
                              <option key={r.role_id} value={r.role_id}>
                                {r.role_name}
                              </option>
                            ))}
                          </select>
                        </div>

                                              <div className="col-md-6 mt-2">
                                                  <h6>Branch Name</h6>
                                                  <input
                                                      type="text"
                                                      className="form-control"
                                                      value={branchName}
                                                      readOnly
                                                  />
                                              </div>
                                              <div className="col-md-6">

                                                  <h6>Associated Branches</h6>

                                                  <div
                                                      className="position-relative"
                                                      style={{
                                                          width: "100%",
                                                          maxWidth: "450px"
                                                      }}
                                                  >

                                                      {/* Dropdown Header */}
                                                      <div
                                                          className="form-control d-flex justify-content-between align-items-center"
                                                          style={{
                                                              cursor: "pointer",
                                                              height: "38px",
                                                              fontSize: "14px"
                                                          }}
                                                          onClick={() =>
                                                              setShowBranchDropdown(!showBranchDropdown)
                                                          }
                                                      >
                                                          <span>
                                                              {selectedBranches.length > 0
                                                                  ? `${selectedBranches.length} Branch(es) Selected`
                                                                  : "Select Branches"}
                                                          </span>

                                                          <span>
                                                              {showBranchDropdown ? "▲" : "▼"}
                                                          </span>
                                                      </div>

                                                      {/* Dropdown Body */}
                                                      {showBranchDropdown && (

                                                          <div
                                                              className="position-absolute bg-white"
                                                              style={{
                                                                  top: "100%",
                                                                  left: 0,
                                                                  width: "100%",
                                                                  minWidth: "350px",
                                                                  maxWidth: "450px",
                                                                  maxHeight: "320px",
                                                                  overflowY: "auto",
                                                                  border: "1px solid #ced4da",
                                                                  borderRadius: "0.375rem",
                                                                  boxShadow: "0 0.5rem 1rem rgba(0,0,0,.15)",
                                                                  zIndex: 9999
                                                              }}
                                                          >

                                                              {/* Search Box */}
                                                              <div
                                                                  className="p-2 sticky-top bg-white"
                                                                  style={{
                                                                      borderBottom: "1px solid #dee2e6"
                                                                  }}
                                                              >
                                                                  <input
                                                                      type="text"
                                                                      className="form-control form-control-sm"
                                                                      placeholder="Search Region / Branch"
                                                                      value={branchSearch}
                                                                      onChange={(e) =>
                                                                          setBranchSearch(e.target.value)
                                                                      }
                                                                  />
                                                              </div>

                                                              {/* Region List */}
                                                              {Object.entries(groupedBranches).map(
                                                                  ([regionName, branches]) => {

                                                                      const filteredBranches =
                                                                          branches.filter(branch =>
                                                                              branch.branch_name
                                                                                  .toLowerCase()
                                                                                  .includes(
                                                                                      branchSearch.toLowerCase()
                                                                                  )
                                                                          );

                                                                      const regionMatches =
                                                                          regionName
                                                                              .toLowerCase()
                                                                              .includes(
                                                                                  branchSearch.toLowerCase()
                                                                              );

                                                                      if (
                                                                          !regionMatches &&
                                                                          filteredBranches.length === 0
                                                                      ) {
                                                                          return null;
                                                                      }

                                                                      const displayBranches =
                                                                          regionMatches
                                                                              ? branches
                                                                              : filteredBranches;

                                                                      return (

                                                                          <div
                                                                              key={regionName}
                                                                              className="p-2 border-bottom"
                                                                          >

                                                                              {/* Region Checkbox */}
                                                                              <div className="form-check mb-2">

                                                                                  <input
                                                                                      type="checkbox"
                                                                                      className="form-check-input"
                                                                                      id={`region_${regionName}`}
                                                                                      checked={
                                                                                          displayBranches.length > 0 &&
                                                                                          displayBranches.every(
                                                                                              branch =>
                                                                                                  selectedBranches.includes(
                                                                                                      branch.branch_id
                                                                                                  )
                                                                                          )
                                                                                      }
                                                                                      onChange={(e) => {

                                                                                          const regionBranchIds =
                                                                                              displayBranches.map(
                                                                                                  branch =>
                                                                                                      branch.branch_id
                                                                                              );

                                                                                          if (e.target.checked) {

                                                                                              setSelectedBranches(prev => [
                                                                                                  ...new Set([
                                                                                                      ...prev,
                                                                                                      ...regionBranchIds
                                                                                                  ])
                                                                                              ]);

                                                                                          } else {

                                                                                              setSelectedBranches(prev =>
                                                                                                  prev.filter(
                                                                                                      id =>
                                                                                                          !regionBranchIds.includes(
                                                                                                              id
                                                                                                          )
                                                                                                  )
                                                                                              );
                                                                                          }
                                                                                      }}
                                                                                  />

                                                                                  <label
                                                                                      className="form-check-label fw-bold text-primary"
                                                                                      htmlFor={`region_${regionName}`}
                                                                                  >
                                                                                      {regionName}
                                                                                  </label>

                                                                              </div>

                                                                              {/* Branch Checkboxes */}
                                                                              <div className="ms-4">

                                                                                  {displayBranches.map(branch => (

                                                                                      <div
                                                                                          key={branch.branch_id}
                                                                                          className="form-check"
                                                                                      >

                                                                                          <input
                                                                                              type="checkbox"
                                                                                              className="form-check-input"
                                                                                              id={`branch_${branch.branch_id}`}
                                                                                              checked={
                                                                                                  selectedBranches.includes(
                                                                                                      branch.branch_id
                                                                                                  )
                                                                                              }
                                                                                              onChange={(e) => {

                                                                                                  if (e.target.checked) {

                                                                                                      setSelectedBranches(
                                                                                                          prev => [
                                                                                                              ...prev,
                                                                                                              branch.branch_id
                                                                                                          ]
                                                                                                      );

                                                                                                  } else {

                                                                                                      setSelectedBranches(
                                                                                                          prev =>
                                                                                                              prev.filter(
                                                                                                                  id =>
                                                                                                                      id !==
                                                                                                                      branch.branch_id
                                                                                                              )
                                                                                                      );
                                                                                                  }
                                                                                              }}
                                                                                          />

                                                                                          <label
                                                                                              className="form-check-label"
                                                                                              htmlFor={`branch_${branch.branch_id}`}
                                                                                          >
                                                                                              {branch.branch_name}
                                                                                          </label>

                                                                                      </div>

                                                                                  ))}

                                                                              </div>

                                                                          </div>
                                                                      );
                                                                  }
                                                              )}

                                                          </div>
                                                      )}

                                                  </div>

                                              </div>
                                              {/* <div className="col-md-6 mt-2">
                                                  <h6>Associated Branch</h6>
                                                  <Select
                                                      isMulti
                                                      isSearchable
                                                      options={branches.map((item) => ({
                                                          value: item.branch_id,
                                                          label: item.branch_name,
                                                      }))}
                                                      value={selectedBranches}
                                                      onChange={(selected) =>
                                                          setSelectedBranches(selected || [])
                                                      }
                                                      placeholder="Select Associated Branches"
                                                      menuPortalTarget={document.body}
                                                      styles={{
                                                          menuPortal: (base) => ({
                                                              ...base,
                                                              zIndex: 9999,
                                                          }),
                                                      }}
                                                  />
                                              </div>*/}
                        <div className="col-md-12">
                          <h6>Password</h6>
                          <div className="input-group">
                            <input
                              type={passwordVisible ? "text" : "password"}
                              required
                              className="form-control"
                              id="password"
                              value={passeedit}
                              onChange={(e) => setpasseedit(e.target.value)}
                            />
                            <div className="input-group-append">
                              <button
                                className="btn btn-outline-secondary"
                                type="button"
                                onClick={togglePasswordVisibility}
                              >
                                <i className={passwordVisible ? "fa fa-eye-slash" : "fa fa-eye"}></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </Modal.Body>
                  <ModalFooter>
                    <div className="row w-100">
                      <div className="col-auto ml-auto">

                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={handleUserUpdate}
                        >
                          UPDATE
                        </button>
                      </div>
                    </div>
                  </ModalFooter>
                </Modal>

                {/* add group */}

                <Modal
                  className="modal-size md modal-top-center"
                  show={group}
                  style={{ display: "flex" }}
                >
                  <Modal.Header>
                    <h6>ADD Group</h6>
                    <span
                      aria-hidden="true"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setgroup(false);
                      }}
                    >
                      ×
                    </span>
                  </Modal.Header>
                  <Modal.Body className="css">
                    <form>
                      <div>
                        <h6>Group Name</h6>
                        <input
                          type="text"
                          className="form-control"
                          id="groupname"
                          value={groupname}
                          onChange={(e) => setgroupname(e.target.value)}
                        />
                      </div>
                      <div className="mt-3">
                        <h6>Description</h6>
                        <textarea
                          className="form-control"
                          id="grpdescrption"
                          style={{ height: "200px" }}
                          value={groupdescr}
                          onChange={(e) => setgroupdescr(e.target.value)}
                        ></textarea>
                      </div>
                    </form>
                  </Modal.Body>
                  <ModalFooter>
                    <div className="col-md-12">
                      <div className="d-flex justify-content-center">
                        <button
                          type="button"
                          className="btn btn-primary"
                          id="savegroup"
                          onClick={handlegroupSubmit}
                        >
                          SAVE
                        </button>
                      </div>
                    </div>
                  </ModalFooter>
                </Modal>
              </div>
            </div>

          </section>
        </div>
      </div>
    </div>
  );
}

export default Userlist;